import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import { forwardRef, useState } from "react";

const passwordPattern =
  /^(?=.*\p{Ll})(?=.*\p{Lu})(?=.*\p{Nd})(?=.*[?!@#$%^&*()[\]~_+-]).{8,64}$/u;

const PasswordField = forwardRef((props, ref) => {
  const [showPassword, setShowPassword] = useState(false);

  const isValid = !props.validate || passwordPattern.test(props.value);

  const errorText = isValid ? "" : props.errorText;

  const onChange = (event) => {
    props.onChange && props.onChange(event);
  };

  const onClickShowPassword = () => setShowPassword((show) => !show);

  const onMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <TextField
      autoComplete="off"
      error={!isValid}
      fullWidth={props.fullWidth}
      helperText={errorText}
      inputProps={{
        autoComplete: "new-password",
        form: {
          autoComplete: "off",
        },
        ref,
      }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={onClickShowPassword}
              onMouseDown={onMouseDownPassword}
              edge="end"
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      }}
      label={props.label}
      onChange={onChange}
      required={props.required}
      type={showPassword ? "text" : "password"}
      value={props.value}
    />
  );
});

export default PasswordField;
